import * as React from 'react';
import { useMediaQuery } from 'react-responsive';
import { ArrowList } from '@telia-front/arrow-list';
import { useIsMounted } from '@telia-front/helper';
import PropsChecker from '@telia-front/props-checker';
import Tabs from '@telia-front/tabs';
import { useTheme } from '@telia-front/theme-provider';
import { TabModalItem } from '../index';
const TabModal = (props) => {
    return (React.createElement(PropsChecker, { componentProps: props, componentName: "TabModal", defaultValueName: "defaultCurrentTab", valueName: "currentTab", onChangeNames: "onTabChange" },
        React.createElement(TabModalInner, Object.assign({}, props))));
};
export const TabModalContext = React.createContext({
    renderedElement: 'tabs',
    currentTab: null,
    setCurrentTab: /* istanbul ignore next */ () => null,
    variant: 'dark',
});
const TabModalInner = (props) => {
    const { breakPoint = 'sm', onTabChange, variant = 'dark' } = props;
    const isMounted = useIsMounted();
    const { media } = useTheme();
    const isLargeScreen = useMediaQuery({
        minWidth: media.width[breakPoint].min,
    });
    const isInitial = React.useRef(true);
    const [internalCurrentTab, setInternalCurrentTab] = React.useState(props.defaultCurrentTab);
    const isCurrentTabControlled = React.useCallback((currentTab = props.currentTab) => {
        return !!onTabChange && typeof currentTab !== 'undefined';
    }, [onTabChange, props.currentTab]);
    const currentTab = isCurrentTabControlled(props.currentTab) ? props.currentTab : internalCurrentTab;
    const renderedElement = isMounted && !isLargeScreen ? 'modal' : 'tabs';
    const setCurrentTab = React.useCallback((tab) => {
        if (!isCurrentTabControlled()) {
            setInternalCurrentTab(tab);
        }
        /* istanbul ignore else */
        onTabChange === null || onTabChange === void 0 ? void 0 : onTabChange(tab);
    }, [isCurrentTabControlled, onTabChange]);
    React.useEffect(() => {
        // If is small screen on mount, ArrowList with Modals is rendered and nothing should be open by default.
        if (!isLargeScreen && isInitial.current) {
            setCurrentTab(null);
            isInitial.current = false;
        }
    }, [isLargeScreen, setCurrentTab]);
    return (React.createElement(TabModalContext.Provider, { value: {
            renderedElement,
            currentTab,
            setCurrentTab,
            variant,
        } }, renderedElement === 'tabs' ? (React.createElement(Tabs, Object.assign({}, props, { align: props.align, currentTab: currentTab || props.defaultCurrentTab, onTabChange: (_, nextTab) => setCurrentTab(nextTab), disableAnalyticsTrigger: true, navigationType: "button-navigation", itemComponent: TabModalItem }), props.children)) : (React.createElement(ArrowList, { outerBordered: true, className: props.className }, props.children))));
};
export default TabModal;
